import React, { memo, Fragment } from 'react';
import { Link } from 'react-router-dom';

const NetworkError = memo(({ message }) => (
  <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
    <h1>NetworkError</h1>
    <div className="row no-gutters">
      <div className="col-lg-12 m-auto">
        <div className="card ">
          <div className="card-body">
            <div className="dashboard-transaction-container text-center">
              <div className="empty-card text-center mt-3">
                <button className="circle-bg-width-80 circle-bg circle-bg-gray">
                  <img
                    src={require('../assets/empty-fee.svg')}
                    className="svg"
                    alt="Min Unit"
                  />
                </button>

                <Fragment>
                  <p>Server Could Not Be Reached</p>
                  <small>{message}</small>
                </Fragment>
              </div>
              <Fragment>
                <Link
                  className="btn btn-primary btn-primary-color  mt-5"
                  to="/"
                >
                  Dashboard
                </Link>
              </Fragment>
            </div>
          </div>
        </div>
        {/* card for outstanding fees */}
      </div>
    </div>

    {/* end card for news display   */}
  </main>
));

export default NetworkError;
